<template>
  <section class="create-rule">
    <header>
      <h1>New Rule</h1>
    </header>
    <p-create-rule-form :is-request-pending="isCreateRequestPending" :is-request-failed="isCreateRequestFailed" @submit="create" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditRuleForm from './_CreateOrEdit';

export default {
  components: {
    'p-create-rule-form': CreateOrEditRuleForm
  },
  computed: {
    ...mapState({
      isCreateRequestPending: s => s.rules.isCreateRequestPending,
      isCreateRequestFailed: s => s.rules.isCreateRequestFailed
    })
  },
  methods: {
    async create(data) {
      try {
        await this.$store.dispatch('rules/create', data);

        this.$toast.success({
          title: 'Create completed',
          message: `Rule was created.`
        });
        this.$router.push({ path: `/rules/` });
      } catch (e) {
        this.$toast.error({
          title: 'Create failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.create-rule {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }
}
</style>
